module.exports = __webpack_public_path__ + "tool.svg?a8b23efdb868bad86b980938c14c46da";


//////////////////
// WEBPACK FOOTER
// ./src/assets/badges/tool.svg
// module id = 91
// module chunks = 0